import React from "react";
import ReactAnimatedWeather from "react-animated-weather";

const codeMapping = {
  "01d": "CLEAR_DAY",
  "01n": "CLEAR_NIGHT",
  "02d": "PARTLY_CLOUDY_DAY",
  "02n": "PARTLY_CLOUDY_NIGHT",
  "03d": "PARTLY_CLOUDY_DAY",
  "03n": "PARTLY_CLOUDY_NIGHT",
  "04d": "CLOUDY",
  "04n": "CLOUDY",
  "09d": "RAIN",
  "09n": "RAIN",
  "10d": "RAIN",
  "10n": "RAIN",
  "11d": "RAIN",
  "11n": "RAIN",
  "13d": "SNOW",
  "13n": "SNOW",
  "50d": "FOG",
  "50n": "FOG",
};

export default function WeatherIcon(props) {
  if (props.icon_url) {
    return (
      <img
        src={props.icon_url}
        alt={props.description}
        className="weather-icon"
        style={{ width: props.size, height: props.size }}
      />
    );
  } else {
    const iconCode = props.code && codeMapping[props.code];

    if (!iconCode) {
      console.error(`No icon mapping found for code: ${props.code}`);
      return null;
    }

    return (
      <ReactAnimatedWeather
        icon={iconCode}
        color="#1e1e1e"
        size={props.size}
        animate={true}
      />
    );
  }
}
